import React from 'react';
import { GridRow, GridColumn } from '@react/react-spectrum/Grid';
import Link from '@react/react-spectrum/Link';

const style = {
  paddingLeft: '10px'
};

export default class ProductsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { columns: 3 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    let width = window.innerWidth;
    if (width < 900) {
      this.setState({ columns: 1 });
    } else if ((width >= 900) & (width <= 1360)) {
      this.setState({ columns: 2 });
    } else {
      this.setState({ columns: 3 });
    }
  }

  renderColumn(size, label, value) {
    return (
      <GridColumn size={size}>
        <div style={style}>
          <Link href={value}>{label}</Link>
        </div>
      </GridColumn>
    );
  }

  renderColumns(columns, products, productIndex, columnBreak) {
    let cols = [];
    let size = 12 / columns;
    for (let columnIndex = 0; columnIndex < columns; columnIndex++) {
      const product = products[productIndex + columnIndex * columnBreak];
      if (product) {
        cols.push(this.renderColumn(size, product.label, product.value));
      }
    }
    return cols;
  }

  renderTable(products) {
    const rows = [];
    let columnBreak = Math.round(products.length / this.state.columns);
    if (columnBreak * this.state.columns < products.length) {
      columnBreak++;
    }
    for (let i = 0; i < columnBreak; i++) {
      rows.push(
        <GridRow align={this.props.align}>
          <GridColumn size={2}> </GridColumn>
          <GridColumn size={8}>
            <GridRow align={this.props.align}>
              {this.renderColumns(this.state.columns, products, i, columnBreak)}
            </GridRow>
          </GridColumn>
          <GridColumn size={2}> </GridColumn>
        </GridRow>
      );
    }
    return rows;
  }

  render() {
    return <>{this.renderTable(this.props.products)}</>;
  }
}
